import { Suspense, useEffect } from 'react';
import { ConfigProvider, Spin, App as AntdApp } from 'antd';
import { RouterProvider } from 'react-router-dom';
import zhCN from 'antd/locale/zh_CN';
import { router } from './router';
import './App.less';
import 'highlight.js/styles/github.css';
import './styles/markdown.less';
import { setMessageInstance } from './utils/message';

const Loading = () => {
	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				height: '100vh',
				width: '100vw',
			}}
		>
			<Spin />
		</div>
	);
};

const AppContent = () => {
	const { message } = AntdApp.useApp();

	useEffect(() => {
		setMessageInstance(message);
	}, [message]);

	return (
		<Suspense fallback={Loading()}>
			<RouterProvider router={router} />
		</Suspense>
	);
};

const App = () => {
	return (
		<ConfigProvider
			locale={zhCN}
			theme={{
				components: {
					Message: {
						colorSuccess: '#513aab',
						colorInfo: '#7f6fea',
					}
				},
				token: {
					colorPrimary: '#513aab',
				},
			}}
		>
			<AntdApp>
				<AppContent />
			</AntdApp>
		</ConfigProvider>
	);
};

export default App;
